var ReportModule = (function () {
    function ReportModule() {
    }
    return ReportModule;
}());
export { ReportModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/report/report.module.ts.pre-build-optimizer.js